import { InventoryTypeFieldOption } from "./InventoryTypeFieldOption"

export class InventoryTypeField {
  id: number
  displayOrder: number
  name: string
  type: number
  isRequired: boolean
  inventoryTypeFieldOptions: InventoryTypeFieldOption[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, displayOrder?: number, name?: string, type?: number, isRequired?: boolean, inventoryTypeFieldOptionsJson?: any) {
    this.id = id
    this.displayOrder = displayOrder ?? 1
    this.name = name ?? ''
    this.type = type ?? 1
    this.isRequired = isRequired ?? false
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.inventoryTypeFieldOptions = inventoryTypeFieldOptionsJson ? inventoryTypeFieldOptionsJson.map((i: any) => new InventoryTypeFieldOption(i.id, i.active, i.displayOrder, i.value)) : []
  }
}
